// extracted by mini-css-extract-plugin
module.exports = {"container":"colorfulBanners__container___3D21_"};